/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Which part of a rendered printout to stream from the Documents service.
 */
export enum EnumPrintoutPart {
    /**
     * <c>GET print_options/{printOptionId}/{primaryId}</c> — the printout document itself.
     */
    Printout = 0,
    /**
     * <c>GET print_options/{printOptionId}/{primaryId}/attachments</c> — the printout's raw attachments
     * merged into one PDF, without the primary document.
     */
    Attachments = 1,
}
